/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Tree_NoticeInputs */

const en_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No penalties or fees. Cancel anytime.`)
};

const ar_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد غرامات أو رسوم. يمكنك الإلغاء في أي وقت.`)
};

const de_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Strafen oder Gebühren. Jederzeit kündbar.`)
};

const es_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin penalizaciones ni cargos. Cancela cuando quieras.`)
};

const fr_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de pénalités ni de frais. Résiliez à tout moment.`)
};

const it_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna penale o commissione. Puoi annullare in qualsiasi momento.`)
};

const ja_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`違約金や手数料なし。いつでもキャンセル可能。`)
};

const ko_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위약금이나 수수료가 없습니다. 언제든지 취소할 수 있습니다.`)
};

const pt_br_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem penalidades ou taxas. Cancele quando quiser.`)
};

const ru_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никаких штрафов и комиссий. Отменяйте в любое время.`)
};

const th_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีค่าปรับหรือค่าธรรมเนียม ยกเลิกได้ทุกเมื่อ`)
};

const tr_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiçbir ceza veya ücret yok. İstediğin zaman iptal edebilirsin.`)
};

const zh_cn_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随时取消，无需额外费用`)
};

const zh_tw_daily_paywall_tree_notice = /** @type {(inputs: Daily_Paywall_Tree_NoticeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隨時取消，無需額外費用`)
};

/**
* | output |
* | --- |
* | "No penalties or fees. Cancel anytime." |
*
* @param {Daily_Paywall_Tree_NoticeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_tree_notice = /** @type {((inputs?: Daily_Paywall_Tree_NoticeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Tree_NoticeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_tree_notice(inputs)
	if (locale === "ar") return ar_daily_paywall_tree_notice(inputs)
	if (locale === "de") return de_daily_paywall_tree_notice(inputs)
	if (locale === "es") return es_daily_paywall_tree_notice(inputs)
	if (locale === "fr") return fr_daily_paywall_tree_notice(inputs)
	if (locale === "it") return it_daily_paywall_tree_notice(inputs)
	if (locale === "ja") return ja_daily_paywall_tree_notice(inputs)
	if (locale === "ko") return ko_daily_paywall_tree_notice(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_tree_notice(inputs)
	if (locale === "ru") return ru_daily_paywall_tree_notice(inputs)
	if (locale === "th") return th_daily_paywall_tree_notice(inputs)
	if (locale === "tr") return tr_daily_paywall_tree_notice(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_tree_notice(inputs)
	return zh_tw_daily_paywall_tree_notice(inputs)
});